import React from 'react';

const navlinks = [
    { 'name': 'Inicio', 'link': '#main' },
    { 'name': 'Picadas', 'link': '#picadas' },
    // { 'name': 'Productos', 'link': '' },
    { 'name': 'Contacto', 'link': '#contact'}
];

const group = navlinks.map((props, i) =>
  <li key={i}>
    <a href={props.link}>{props.name}</a>
  </li>
);

function NavbarList () {
  return (
    <ul id='navegacion' className='nav navbar-nav navbar-left'>
      {group}
    </ul>
  );
}

function NavbarListResponsive () {
  return (
    <ul className='dropdown-menu' aria-labelledby='dropdownMenu1'>
      {group}
    </ul>
  );
}

function Navbar () {
  return (
    <nav className='navbar navbar-fixed-top encabezado' >
      <div className='row'>
        <div className='col-xs-3 col-md-5'>
          <div id='barra'>
            <NavbarList />
          </div>
          <div className='dropdown' id='movil'>
            <button className='btn btn-movil dropdown-toggle' type='button' id='dropdownMenu1' data-toggle='dropdown' aria-haspopup='true' aria-expanded='true'>
              <i className='fa fa-bars fa-4x'></i>
            </button>
            <NavbarListResponsive />
          </div>
        </div>

        <div className='col-xs-9 col-md-3'>
          <div className='logo'>
            <img src={require('../img/logosm.png')} alt='' />
          </div>
        </div>
        <div className='text-right tel col-xs-12 col-md-4'>
          <h1><small><i className='fa fa-phone fa-2x'></i></small>0223 475-8406</h1>
        </div>
        <div id='face'>
          <a href='https://www.facebook.com/PicadaClubtablasdepicadas' target='blank'>
            <img src={require('../img/faceChico.png')} width='90px' alt='' />
          </a>
        </div>

      </div>
    </nav>
  );
}

export default (props) => {
      return (
      <Navbar />
    );
}





/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/